<template>
  <div class="grid gap-4" v-if="restaurants.length">
    <AtomBlockHeaderSeo 
      :label="$t('city.start.restaurants.label', { city: fat.city?.name })" 
      :heading="$t('city.start.restaurants.heading', { city: fat.city?.name })"
    />
    <BlocksRestaurantListStandard class="!my-0" :block="{ data: { restaurants: restaurants }}" />
    <NuxtLink class="flex items-center gap-2 border-t pt-4" :to="`/${$t('routes.restaurants')}/${fat.city?.slug}`" :class="{ 'hidden': restaurants.length < 12 }">
      <div class="w-5 h-5 flex items-center justify-center rounded-full bg-sky text-ocean">
        <AtomIcon name="chevron-right" class="text-sm" />
      </div>
      <div class="text-sm">{{ $t('shared.allRestaurants', { city: fat.city?.name }) }}</div>
    </NuxtLink>
  </div>
</template>

<script setup>
const fat = useFatStore()

// Fetch restaurants by City ID's
const { data } = await useFetch('/restaurants', { 
  key: `restaurants-city-start-${fat.city?.slug}`,
  baseURL: useEnv('apiBase'),
  query: {
    scope: 'bokabord.se',
    bookable: true,
    limit: 12,
    offset: 0,
    sortBy: 'featured',
    orderBy: 'desc',
    cities: computed(() => fat.cityIds?.join(',')),
  }
})

// Append rest ID's on initial load
const restaurants = ref(data.value?.data)
</script>
